<template>
  <div
    class="sch-class"
    :style="{ background: `linear-gradient(118.35deg,
     ${bgColors[0]} 20.77%, ${bgColors[1]} 83.52%)`}"
    @click="$emit('select')"
  >
    <div class="sch-class-info">
      <header class="cls-title">
        <p class="cls-title-name" :style="{ color: bgColors[0] }">{{ name }}</p>
        <p class="cls-title-subject">{{ subject }}</p>
      </header>
      <div class="cls-params">
        <p><span>Timeframe: </span>{{ timeframe }}</p>
        <p><span>Grade: </span>{{ grade }}</p>
        <p><span>Location: </span>{{ location }}</p>
      </div>
      <footer class="cls-footer">
        <div class="cls-footer-counter">Students: {{ studentsCount }}</div>
        <svg class="cls-footer-icon" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path :fill="bgColors[0]"
          d="
          M30.8016
           17.3446L28.5926
            15.1332L20
             23.7281L11.4051
              15.1332L9.19608
               17.3446L20
                28.1462L30.8016
                 17.3446ZM20
                  3.12457C10.6946
                   3.12457
                   3.12457
                    10.6946
                     3.12457
                      20C3.12457
                       29.3054
                        10.6946
                         36.8754
                          20
                           36.8754C29.3054
                            36.8754
                             36.8732
                              29.3054
                               36.8732
                                20C36.8732
                                 10.6946
                                  29.3054
                                   3.12457
                                    20
                                     3.12457ZM20
                                      40C14.6573
                                       40 9.63334
                                        37.9185
                                         5.85744
                                          34.1426C2.07925
                                           30.3644
                                            0 25.3427
                                             0
                                              20C0 14.6573
                                               2.07925
                                                9.63561
                                                 5.85744
                                                  5.85743C9.63334
                                                   2.08153 14.6573
                                                    0 20 0C25.3427
                                                     0 30.3644
                                                      2.08153
                                                       34.1426
                                                        5.85743C37.9185
                                                         9.63561
                                                          40 14.6573
                                                           40
                                                            20C40
                                                             25.3427
   37.9185 30.3644 34.1426 34.1426C30.3644 37.9185 25.3427 40 20 40Z"/>
        </svg>
      </footer>
    </div>
  </div>
</template>

<script>
import { getColorForSubject } from '@/helpers/getColorForSubject';

export default {
  name: 'SchoolClassCard',
  props: {
    name: {
      type: String,
      required: true,
    },
    subject: {
      type: String,
      required: true,
    },
    timeframe: {
      type: String,
      required: true,
    },
    grade: {
      type: String,
      required: true,
    },
    location: {
      type: String,
      required: true,
    },
    studentsCount: {
      type: Number,
      required: true,
    },
  },
  computed: {
    bgColors() {
      return getColorForSubject(this.subject);
    },
  },
};
</script>

<style scoped lang="scss">
.sch-class {
  box-shadow: 0px 0px 10px 4px rgba(0, 0, 0, 0.1);
  border-radius: 30px;
  max-width: 310px;
  width: 100%;
  padding: 10px;
  cursor: pointer;

  &-info {
    background: #FFFFFF;
    border-radius: 25px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .cls-title {
      border-bottom: 1px solid #D2D2D2;
      margin: 0 16px 16px;
      p {
        text-align: center;
        text-transform: uppercase;
      }
      &-name {
        font-size: 32px;
        padding-top: 10px;
        margin-bottom: 6px;
        max-height: 78px;
        overflow: hidden;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        line-height: 36px;
      }
      &-subject {
        font-size: 14px;
        color: #256680;
      }
    }

    .cls-params {
      p {
        font-size: 14px;
        line-height: 17px;
        text-align: center;
        color: #717171;

        span {
          text-transform: uppercase;
        }
      }
    }

    .cls-footer {
      &-counter {
        width: 120px;
        height: 26px;
        background-color: #78FF8E;
        border: 1px solid #CFC6C6;
        border-radius: 20px;
        font-size: 12px;
        line-height: 26px;
        text-align: center;
        color: #717171;
        margin: 0 auto;
      }

      &-icon {
        display: block;
        margin: 12px auto 8px;
      }
    }
  }
}
</style>
